import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
// import {Link} from "react-router-dom"
import { LinearProgress, FormHelperText, Button, Dialog, TextField, DialogTitle, DialogContent, DialogContentText, DialogActions, CircularProgress } from '@material-ui/core'
import "../styles/ApplicationHome.css"
import { useHistory } from 'react-router-dom';

function ApplicationHome() {
    const [IsOpen1, setIsOpen1] = useState(false)
    const [IsOpen2, setIsOpen2] = useState(true)
    const [Type, setType] = useState('')
    const [Fee, setFee] = useState(0)
    const dispatch = useDispatch();
    const history = useHistory();
    useEffect(() => {
        const result = JSON.parse(localStorage.getItem("amount"))
        localStorage.setItem("type", JSON.stringify(Type))
        if (Type === 'single') {
            setIsOpen1(true)
            setFee(result);
        }
        else if (Type === 'student') {
            history.replace("/StudentPayment")

            setFee(result);
        }
        else if (Type === 'couple') {
            history.replace("/LifeMemberpage")
        }
        else if (Type === 'MBBs')
            //  var a="23"
            setFee(result)

        else if (Type === 'BDS')
            //   var b="12"
            setFee(result)

        else if (Type === '1st')
            //   var c="1"
            setFee(89)

        else
            setFee(0);
    }, [Type])

    const handleRegister = () => {
        dispatch({ type: "SET_FORM_TYPE", payload: Type });
        dispatch({ type: "SET_FORM_FEE", payload: Fee });
        history.push('/membership/signup')
    }
   
    const handleSubApp = () => {
        history.replace("/StudentMembers")
        setIsOpen2(true)
        setIsOpen1(false);
    }
    const handleNoApp = () => {
        setIsOpen2(false)                // 20 oct jyoti add this function for reject
        setIsOpen1(false);
        history.replace("/LifeMemberpage")

    }

    return (
        <>
            <div className="appHome">
                <h1 className="appHomeHeader">NMO Online Membership Portal</h1>
                <div style={{ textAlign: 'center', height: 'auto', display: 'flex', flexDirection: 'column', gap: "30px", width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: "30px", width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                        <div className="quesCon">
                            <h3>Register Yourself for</h3>
                            <select className="newSelect" onChange={(e) => setType(e.target.value)}>
                                <option value='none'>Select Membership</option>
                                <option value='single'>Single Doctor Membership</option>
                                <option value='couple'>Couple Doctor Membership</option>
                                <option value='student'>Student Membership</option>
                            </select>
                        </div>
                    </div>
                </div>
                <Dialog open={IsOpen1} >
                    <DialogTitle >{"NMO Membership Portal"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Click Yes if you have a valid NMO Student Membership ID
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleSubApp} color="primary">
                            Yes
                        </Button>
                        <Button onClick={handleNoApp} color="secondary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>

            </div>


        </>
    )
}

export default ApplicationHome
